import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreAllCategories } from "../../api/apiCategories";
import parseError from "../../utils/parseError";

const useRestoreAllCategories = () => {
    const queryClient = useQueryClient();

    const {
        mutate: restoreAllCat,
        isPending: isRestoreAll,
    } = useMutation({
        mutationFn: restoreAllCategories,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["categories"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore categories");
        },
    });

    return {
        restoreAllCat,
        isRestoreAll,
    };
};

export default useRestoreAllCategories;
